import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";
import { useEffect } from "react";
import { scrollToTop } from "../../Layout/Common/common";

export const CheckoutTitle = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div className="col-lg-12 checkout-lft-title">
      <div className="wesproduct-title cart-title">
        <h1>Order Checkout</h1>
        <Link to={PAGES.ORDER_DETAIL} className="return-link">
          <i className="fa-solid fa-chevron-left" /> Return to Cart
        </Link>
      </div>
    </div>
  );
};
